import { FelaCSS, colors } from '@bridebook/ui';

const placeHolderShimmer = {
  '0%': { left: '-100%' },
  '100%': { left: '100%' },
} as unknown as FelaCSS['animationName'];

export const wrapStyle: FelaCSS = {
  position: 'relative',
  width: '100%',
};

export const animationWrap: FelaCSS = {
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  backgroundColor: colors.soft,
  overflow: 'hidden',
};

export const animationBlock: FelaCSS = {
  content: '',
  display: 'block',
  position: 'relative',
  height: '100%',
  animationDuration: '2s',
  animationIterationCount: 'infinite',
  animationName: placeHolderShimmer,
  backgroundImage: `linear-gradient(90deg, ${colors.soft} 0%, ${colors.white} 45%, ${colors.white} 55%, ${colors.soft} 100%);`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 100%',
};
